import { io } from 'socket.io-client';

class SocketioService {
    socket = null;
    constructor() {}

    setupSocketConnection() {
        if (this.socket) {
            if (!this.socket.connected) {
                this.socket.connect();
            }
            return this.socket;
        }

        // Sanea el endpoint: Vue CLI NO quita comentarios inline del .env, así que un
        // valor con un "# comentario" pegado llegaría con el comentario y espacios
        // dentro del valor → produciría una URL wss:// rota (…%20%20%20/socket.io) y el
        // realtime nunca conectaría. Quitamos todo lo que vaya tras un '#' y recortamos
        // espacios para que la URL sea siempre válida.
        const endpoint = `${process.env.VUE_APP_SOCKET_ENDPOINT || ''}`.split('#')[0].trim();

        if (process.env.NODE_ENV !== 'production') {
            console.log('[SOCKET] setup connection', {
                endpoint,
                page_origin: window.location.origin,
                page_protocol: window.location.protocol,
            });
        }

        this.socket = io(endpoint, {
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: Infinity, // nunca rendirse
            reconnectionDelay: 1000,
            reconnectionDelayMax: 8000,     // backoff hasta 8s
            timeout: 10000,
        });

        this.socket.on('connect', () => {
            if (process.env.NODE_ENV !== 'production') {
                console.log('[SOCKET] connect', {
                    id: this.socket?.id || null,
                    endpoint,
                    transport: this.socket?.io?.engine?.transport?.name || null,
                });
            }
        });

        this.socket.on('connect_error', (error) => {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[SOCKET] connect_error', {
                    endpoint,
                    message: error?.message || error,
                    description: error?.description || null,
                    context: error?.context || null,
                });
            }
        });

        this.socket.on('disconnect', (reason) => {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[SOCKET] disconnect', {
                    endpoint,
                    reason,
                });
            }
        });

        if (process.env.NODE_ENV !== 'production' && this.socket.onAny) {
            this.socket.onAny((eventName, ...args) => {
                console.log('[SOCKET] onAny', {
                    event: eventName,
                    payload: args?.[0] ?? null,
                });
            });
        }

        if (typeof window !== 'undefined') {
            window.__crmSocket = this.socket;
        }

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }
}

export default new SocketioService();
